import { ITEM_CARD_DEFINITIONS } from "game/data/item-cards/item-card-definitions";
import { ItemCardDefinition } from "types/item-cards/item-card-definition";

const ITEM_CARD_DEFINITIONS_BY_KEY = new Map<string, ItemCardDefinition>(
  ITEM_CARD_DEFINITIONS.map((definition) => [definition.key, definition]),
);

export const getItemCardDefinition = (
  itemCardKey: string,
): ItemCardDefinition | undefined => ITEM_CARD_DEFINITIONS_BY_KEY.get(itemCardKey);
